<script setup lang="ts">
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'
import ElementalsAccordionList from '@/components/DrawerSidebarRight/components/ElementalsAccordionList/index.vue'
import type { AccordeonEmits } from '@/components/Accordion/index.vue'

const emits = defineEmits<AccordeonEmits>()
const { elementalsFiltered, isLoading, refetch } = useRecentElementals()

const user = useUser()
const { state, toggleRecentAccordion } = useElementalListsStore()

const handleClose = () => {
  toggleRecentAccordion(false)
}

const handlerOpen = () => {
  toggleRecentAccordion(true)
}

const handleToggle = (isOpen?: boolean) => {
  emits('onToggle', isOpen)
}

onMounted(() => {
  refetch()
})
</script>

<template>
  <div v-if="user">
    <ElementalsAccordionList
      title="Recents"
      icon-class="bg-gray-300 h-7 w-7"
      icon-name="i-mdi:clock-outline text-dark-gray"
      :elementals="elementalsFiltered.slice(0, 5).map(list => ({ ...list, id: list.isList ? list.id_list.toString() : list.id }))"
      :is-open="state.recentAccordionOpen"
      :is-loading="isLoading"
      :columns="['title']"
      :folder-level="1"
      row-class="!pl-8"
      elemental-label="Recents"
      :show-empty-state="true"
      @on-close="handleClose"
      @on-open="handlerOpen"
      @on-toggle="handleToggle"
    />
  </div>
</template>

<style lang="css" module>
  .boxColors {
  }
</style>

<style module lang="css">
.arrow_icon {
      @apply w-9 h-9 text-dark-gray;
      transition: transform 0.3s ease-in-out;
      pointer-events: none !important;
    }
</style>
